import {post} from '@/utils/request'

// // 上传文件
// export function uploadFile(data) {
//   return post({
//     url: `!service/file/~java/Uploader.upload`,
//     data,
//     headers: {
//       'Content-Type': 'multipart/form-data'
//     }
//   })
// }

// 获取运营商数量
export function getOperatorCount(data) {
    return post({
        data,
        url: '!Rpt/Watch/DataReport/~java/BusinesseBasicStatistics.getOperatorCount'
    })
}
// 获取号卡数量
export function getCardCount(data) {
    return post({
        data,
        url: '!Rpt/Watch/DataReport/~java/BusinesseBasicStatistics.getCardCount'
    })
}

// 获取套餐数量
export function getPackageCount(data) {
    return post({
        data,
        url: '!Rpt/Watch/DataReport/~java/BusinesseBasicStatistics.getPackageCount'
    })
}

// 获取指定会员的下一级代理商
export function getAgentsMap(data) {
    return post({
        data,
        url: '!Rpt/Watch/DataReport/~query/Q_BUSINESSE_BASIC_STATISTICS.getNextOneLevelMember'
    })
}

// 获取指定会员的所有下级代理商
export function getAllAgentsMap(data) {
    return post({
        data,
        url: '!Rpt/Watch/DataReport/~query/Q_BUSINESSE_BASIC_STATISTICS.getNextAllLevelMember'
    })
}

// 获取业务详情（查看详情）
export function getDataDetailReq(data) {
    return post({
        data,
        url: '!Rpt/Watch/DataReport/~java/BusinesseBasicStatistics.getDataDetail'
    })
}

// 业务详情导出
export function getDataDetailExport(data) {
    return post({
        data,
        url: '!Rpt/Watch/DataReport/~java/BusinesseBasicStatistics.getDataDetailExport'
    })
}

// 获取号码多种状态数量
export function getMultipleStatusNum(data) {
    return post({
        data,
        url: '!Rpt/Watch/DataReport/~java/NumberCardStatistics.getMultipleStatusNum'
    })
}

// 获取号码多种状态数量(详情页面)
export function getNumCardDetailStatusReq(data) {
    return post({
        data,
        url: '!Rpt/Watch/DataReport/~java/NumberCardStatistics.getMultipleStatusNum'
    })
}

// 获取号码统计详情(详情页面)
export function getNumCardDetailReq(data) {
    return post({
        data,
        url: '!Rpt/Watch/DataReport/~java/NumberCardStatistics.getMultipleStatusDetail'
    })
}

// 号码统计详情导出(详情页面)
export function uploadNumCardDetailReq(data) {
    return post({
        data,
        url: '!Rpt/Watch/DataReport/~java/NumberCardStatistics.getMultipleStatusDetailExport'
    })
}


// 获取套餐
export function getPackagesSel (param) {
    return post({
        url: `!Busi/Commission/~java/PhoneWatchCommission.getPackages`,
        data: param
    })
}

// 获取月激活数总和
export function getMonthlyActivationReq (param) {
    return post({
        url: `!Report/~java/NumberStatisticsWX.getActiveNumByMonth`,
        data: param
    })
}

// 统计激活数日分析
export function getActDayStatReq (param) {
    return post({
        url: `!Report/~java/NumberStatisticsWX.getActiveNumAccurateDayByMonth`,
        data: param
    })
}

// 获取月佣金总和
export function getMonthlyCommissionReq (param) {
    return post({
        url: `!Busi/Commission/~java/PhoneWatchCommission.getMonthlyCommission`,
        data: param
    })
}

// 统计佣金日分析
export function getCommDayStatReq (param) {
    return post({
        url: `!Busi/Commission/~java/PhoneWatchCommission.getDayStat`,
        data: param
    })
}

// 统计佣金详情页
export function getCommissionDetailReq(data) {
  return post({
    data,
    url: '!Rpt/Watch/DataReport/~java/CommissionStatistics.getCommissionStatisticsDetail'
  })
}


// 获取当前登录会员信息
export function getCurrentLoginMemberInfoReq(data) {
  return post({
    data,
    url: '!Rpt/Watch/DataReport/~java/MemberStatistics.getCurrentLoginMemberInfo'
  })
}

// 获取指定会员的上一级
export function getUpOneLevelMemberReq(data) {
  return post({
    data,
    url: '!Rpt/Watch/DataReport/~java/BusinesseBasicStatistics.getUpOneLevelMember'
  })
}

// 获取指定会员的下一级代理商数量
export function getNextLevelMemberCountReq(data) {
  return post({
    data,
    url: '!Rpt/Watch/DataReport/~java/MemberStatistics.getMemberCount'
  })
}

// 获取指定会员的下一级拿卡总量
export function getNextLevelCardCountReq(data) {
  return post({
    data,
    url: '!Rpt/Watch/DataReport/~java/MemberStatistics.getCardCount'
  })
}

// 获取指定会员的下一级代理商拿卡明细
export function getNextLevelMemberCardDetailReq(data) {
  return post({
    data,
    url: '!Rpt/Watch/DataReport/~java/MemberStatistics.getNextLevelMemberCardDetail'
  })
}
